import { useState } from "react";
import { api, ApiError } from "../api";

export default function LoginView({ onAuthed }: { onAuthed: () => void }) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(pw);
      onAuthed();
    } catch (err) {
      setError(err instanceof ApiError && err.status === 401 ? "Wrong password." : "Login failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="login-card" onSubmit={submit}>
      <h1>Edge</h1>
      <p>Trend-resumption setup workbench</p>
      <input
        type="password"
        autoFocus
        autoComplete="current-password"
        value={pw}
        onChange={(e) => setPw(e.target.value)}
        placeholder="Password"
      />
      {error && <div className="error">{error}</div>}
      <div className="row">
        <button type="submit" className="primary" disabled={busy} style={{ flex: 1 }}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </div>
    </form>
  );
}
